import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import SimplePanel from '@/shared/components/SimplePanel';
import { injectIntl, FormattedMessage, FormattedNumber } from 'react-intl';
import utils from '@/shared/utils/adminpulse';
import FormattedListValue, { listItemMsg } from '@/shared/components/FormattedListValue';
import Checkbox from '@/shared/components/input/Checkbox';
import messages from '../jobMessages';
import api from '@/shared/api';
import config from '@/config';
import CurrencySymbol from '@/shared/components/CurrencySymbol';
import FormattedDateShort from '@/shared/components/FormattedDateShort';

const JobDetailReprocessInvoiceStreamSchedule = ({ job, intl }) => {
  const [invoiceSchedule, setInvoiceSchedule] = useState(null);

  // Some json parameters might still be stored without camelcase in the db, so convert it to camelcase just in case
  const parameters = utils.toCamel(job.parameters);
  useEffect(() => {
    let mounted = true;
    api.base.get(`${config.appUrls.api}/api/InvoiceSchedule/Get`).then(({ data }) => {
      if (!mounted) return;
      setInvoiceSchedule(data.find(x => x.id === parameters.invoiceScheduleId));
    });
    return () => {
      mounted = false;
    };
  }, [parameters, intl]);

  if (!parameters) return null;
  return (
    <SimplePanel title={<FormattedListValue list="jobType" id={job.jobType} />}>
      <div className="info-block container-fluid radius4B">
        <div className="row">
          <div className="col-lg-6">
            <div className="row">
              <div className="col-md-5 col-sm-6">
                <label>
                  <b>
                    <FormattedMessage {...messages.InvoicingType} />
                  </b>
                </label>
              </div>
              <div className="col-md-7 col-sm-6">
                <FormattedListValue
                  list="InvoiceSchedule"
                  id={parameters.invoiceScheduleId}
                  fallback={invoiceSchedule?.name}
                />
              </div>
            </div>
            {!!invoiceSchedule && (
              <div className="row">
                <div className="col-md-5 col-sm-6">
                  <label>
                    <b>
                      <FormattedMessage {...messages.InvoiceSchedule} />
                    </b>
                  </label>
                </div>
                <div className="col-md-7 col-sm-6">
                  <FormattedListValue list="InvoicingType" id={invoiceSchedule.invoicingType} />
                </div>
              </div>
            )}
          </div>
          <div className="col-lg-6">
            <div className="row">
              <div className="col-md-5 col-sm-6">
                <label>
                  <b>
                    <FormattedMessage {...messages.InvoiceCreationDate} />
                  </b>
                </label>
              </div>
              <div className="col-md-7 col-sm-6">
                <div>
                  <FormattedDateShort value={parameters.invoiceCreationDate} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </SimplePanel>
  );
};

JobDetailReprocessInvoiceStreamSchedule.propTypes = {
  job: PropTypes.shape({}).isRequired,
};

export default injectIntl(JobDetailReprocessInvoiceStreamSchedule);
